import React, { useEffect, useState, createContext } from 'react';
import { Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { HelmetProvider } from 'react-helmet-async';
import 'react-toastify/dist/ReactToastify.css';


// Layout Components
import Header from './components/Layout/Header';
import Footer from './components/Layout/Footer';
import WhatsAppButton from './components/Layout/WhatsAppButton';
import CallButton from './components/Layout/CallButton';
import ScrollToTop from './components/Common/ScrollToTop';

// Pages
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Calculators from './pages/Calculators';
import Contact from './pages/Contact';
import Blogs from './pages/Blogs';
import BlogDetail from './pages/BlogDetail';
import AdminLogin from './pages/Admin/Login';
import AdminDashboard from './pages/Admin/Dashboard';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';
import MutualFundDisclaimer from './pages/MutualFundDisclaimer';
import InsuranceDisclaimer from './pages/InsuranceDisclaimer';

// Components
import AIChatbot from './components/Chatbot/AIChatbot';

// Data
import { initialServices } from './data/servicesData';
import { initialBlogs } from './data/blogsData';

export const AppContext = createContext();

function App() {
  const [services, setServices] = useState([]);
  const [blogs, setBlogs] = useState([]);
  const [leads, setLeads] = useState([]);
  const [isAdminLoggedIn, setIsAdminLoggedIn] = useState(false);

  useEffect(() => {
    // Load data from localStorage
    const savedServices = localStorage.getItem('wisdom_services');
    const savedBlogs = localStorage.getItem('wisdom_blogs');
    const savedLeads = localStorage.getItem('wisdom_leads');
    const adminAuth = localStorage.getItem('wisdom_admin_auth');

    setServices(savedServices ? JSON.parse(savedServices) : initialServices);
    setBlogs(savedBlogs ? JSON.parse(savedBlogs) : initialBlogs);
    setLeads(savedLeads ? JSON.parse(savedLeads) : []);
    setIsAdminLoggedIn(adminAuth === 'true');
  }, []);

  const saveServices = (newServices) => {
    localStorage.setItem('wisdom_services', JSON.stringify(newServices));
    setServices(newServices);
  };

  const saveBlogs = (newBlogs) => {
    localStorage.setItem('wisdom_blogs', JSON.stringify(newBlogs));
    setBlogs(newBlogs);
  };

  const saveLeads = (newLeads) => {
    localStorage.setItem('wisdom_leads', JSON.stringify(newLeads));
    setLeads(newLeads);
  };

  const addLead = (lead) => {
    const newLeads = [lead, ...leads];
    saveLeads(newLeads);
  };

  const handleAdminLogin = (email, password) => {
    if (email === 'admin@wisdomconsultancy.com' && password === 'admin123') {
      localStorage.setItem('wisdom_admin_auth', 'true');
      setIsAdminLoggedIn(true);
      return true;
    }
    return false;
  };

  const handleAdminLogout = () => {
    localStorage.removeItem('wisdom_admin_auth');
    setIsAdminLoggedIn(false);
  };

  return (
    <HelmetProvider>
      <AppContext.Provider value={{
        services, setServices: saveServices,
        blogs, setBlogs: saveBlogs,
        leads, addLead,
        isAdminLoggedIn,
        handleAdminLogin,
        handleAdminLogout
      }}>
        <ScrollToTop />
        <div className="min-h-screen flex flex-col">
          <Header />
          <main className="flex-grow pt-20">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/calculators" element={<Calculators />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/blogs" element={<Blogs />} />
              <Route path="/blogs/:slug" element={<BlogDetail />} />
              <Route path="/admin" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms" element={<TermsConditions />} />
              <Route path="/mutual-fund-disclaimer" element={<MutualFundDisclaimer />} />
              <Route path="/insurance-disclaimer" element={<InsuranceDisclaimer />} />
            </Routes>
          </main>
          <Footer />
          <WhatsAppButton />
          <CallButton />
          <AIChatbot />
        </div>
        <ToastContainer position="bottom-right" autoClose={5000} />
      </AppContext.Provider>
    </HelmetProvider>
  );
}

export default App;